import { css } from '@emotion/react'
import { Fragment } from 'react'

import { FormLightbox } from '@/features/forms'

export type LightboxContentData = Queries.FormLightboxFragment
interface Props {
  data?: LightboxContentData | null
}
export const LightboxContent = ({ data }: Props) => {
  const style = css`
    background: #fff;
    grid-column: 2 / 3;
    grid-row: 2 / 3;
  `
  switch (data?.__typename) {
    case 'DatoCmsFormLightbox':
      return (
        <FormLightbox
          data={data}
          layout="LIGHTBOX"
          css={style}
        />
      )
    default:
      return <Fragment />
  }
}
